"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotUpdate = void 0;
var const_1 = require("./config/const");
var utils_1 = require("./utils");
var HotUpdate = /** @class */ (function () {
    function HotUpdate(opts) {
        var _a;
        opts = opts !== null && opts !== void 0 ? opts : {};
        this.options = opts;
        this.events = this.options.events;
        this.fallbackCdnDomains = (_a = opts.fallbackCdnDomains) !== null && _a !== void 0 ? _a : const_1.FALLBACK_CDNS;
    }
    HotUpdate.prototype.execCallback = function (eventName, args) {
        if (this.events && typeof this.events[eventName] === 'function') {
            this.events[eventName](args);
        }
    };
    HotUpdate.prototype.getBaseInfo = function () {
        var variable = this.options.variable || '__HOT_UPDATE_CDN__';
        var cdnInfo = window[variable] || {};
        var prefix = cdnInfo.prefix || '';
        return {
            path: window.location.pathname,
            locale: this.k18n.locale,
            url: window.location.href,
            prefix: prefix,
            cdnInfo: window[variable],
        };
    };
    HotUpdate.prototype.destroy = function () {
        /* do nothing */
    };
    HotUpdate.prototype.apply = function (k18n) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.k18n = k18n;
                if (this.k18n) {
                    if (!this.cdnUrl) {
                        this.execCallback('NO_MATCHED_CDN', __assign(__assign({}, this.getBaseInfo()), { type: 'NO_MATCHED_CDN' }));
                        return [2 /*return*/];
                    }
                    this.update();
                    this.k18n.on('LOCALE_CHANGED', function () {
                        _this.update();
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    HotUpdate.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFresh()];
                    case 1:
                        response = _a.sent();
                        if (!response)
                            return [2 /*return*/];
                        this.remoteMessages = response;
                        if (this.options.customHandler && typeof this.options.customHandler === 'function') {
                            this.options.customHandler(response, this.k18n);
                            return [2 /*return*/];
                        }
                        if (this.shouldUseFresh()) {
                            this.k18n.addMessages(this.remoteMessages);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HotUpdate.prototype.shouldUseFresh = function () {
        var _a, _b;
        // 比较时间戳
        // cdn 上的时间戳是否比本地文件的新
        var old = (_a = this.k18n) === null || _a === void 0 ? void 0 : _a.messagesMeta;
        if (!old)
            return true;
        var oldTs = old.timestamp || 0;
        var newTs = ((_b = this.remoteMessages) === null || _b === void 0 ? void 0 : _b.timestamp) || 0;
        return newTs > oldTs;
    };
    HotUpdate.prototype.getFresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, cdnUrl_1, fallbackCdnDomains, queue_1, currentFetchTime_1, status_1, freshLangs_1, fetchOpts, error_1, error_2;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        _a = this, cdnUrl_1 = _a.cdnUrl, fallbackCdnDomains = _a.fallbackCdnDomains;
                        if (!cdnUrl_1) {
                            return [2 /*return*/];
                        }
                        queue_1 = [cdnUrl_1].concat(fallbackCdnDomains.map(function (domain) { return _this.replaceDomain(cdnUrl_1, domain); }));
                        currentFetchTime_1 = 0;
                        fetchOpts = {
                            method: 'GET',
                        };
                        if (this.options.noCache) {
                            fetchOpts.cache = 'no-cache';
                        }
                        _b.label = 1;
                    case 1:
                        if (!(status_1 !== 200 && status_1 !== 404 && currentFetchTime_1 < queue_1.length)) return [3 /*break*/, 6];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, fetch(queue_1[currentFetchTime_1], fetchOpts).then(function (res) {
                                status_1 = res.status;
                                if (!res.ok) {
                                    _this.execCallback('CDN_REQUEST_ERROR', __assign({ type: 'CDN_REQUEST_ERROR', status: res.status }, _this.getBaseInfo()));
                                    console.error("\u70ED\u66F4\u65B0 cdn \u8BF7\u6C42\u5931\u8D25\uFF0Cstatus \u4E3A ".concat(status_1, ", url \u4E3A ").concat(queue_1[currentFetchTime_1]));
                                    return;
                                }
                                return res.json();
                            }).then(function (res) {
                                if (!res)
                                    return;
                                freshLangs_1 = res;
                                var remoteTs = res.timestamp;
                                var localeTimestamp = _this.k18n.messagesMeta && _this.k18n.messagesMeta.timestamp || 0;
                                _this.execCallback('CDN_TIMESTAMP', __assign(__assign({}, _this.getBaseInfo()), { type: 'CDN_TIMESTAMP', timestamp: remoteTs, localeTimestamp: localeTimestamp, isNew: remoteTs >= localeTimestamp }));
                            })];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        this.execCallback('NETWORK_ERROR', __assign(__assign({}, this.getBaseInfo()), { type: 'NETWORK_ERROR', err_msg: error_1.message }));
                        console.error(error_1);
                        return [3 /*break*/, 5];
                    case 5:
                        currentFetchTime_1 += 1;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/, freshLangs_1];
                    case 7:
                        error_2 = _b.sent();
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(HotUpdate.prototype, "cdnUrl", {
        get: function () {
            var locale = this.k18n.locale;
            var variable = this.options.variable || '__HOT_UPDATE_CDN__';
            var cdnMap = window[variable] || {};
            if (!cdnMap.exists && !this.options.forceFetch)
                return '';
            if (cdnMap[locale])
                return cdnMap[locale];
            if (cdnMap.prefix) {
                return "".concat(cdnMap.prefix).concat(locale, ".json");
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    HotUpdate.prototype.replaceDomain = function (origin, domain) {
        if (!origin)
            return '';
        var originDomain = (0, utils_1.extractDomain)(origin);
        return origin.replace(originDomain, domain);
    };
    HotUpdate.key = 'cdnHotUpdate';
    return HotUpdate;
}());
exports.HotUpdate = HotUpdate;
